import api from './api'
import { API_ENDPOINTS } from '@/utils/constants'

export const authService = {
  async login(credentials) {
    return api.post(API_ENDPOINTS.AUTH.LOGIN, credentials)
  },

  async logout() {
    return api.post(API_ENDPOINTS.AUTH.LOGOUT)
  },

  async getCurrentUser() {
    return api.get(API_ENDPOINTS.AUTH.USER)
  },

  async refreshToken() {
    return api.post(API_ENDPOINTS.AUTH.REFRESH)
  },

  async getGoogleOAuthConfig() {
    return api.get(API_ENDPOINTS.AUTH.GOOGLE_CONFIG)
  },

  async loginWithGoogle(code) {
    return api.post(API_ENDPOINTS.AUTH.GOOGLE_CALLBACK, { code })
  }
}
